
import Component from 'vue-class-component';
import Vue from 'vue'
import { menuStore } from '@/stores/index'
@Component
export default class HeaderMenu extends Vue{
    menu = menuStore();
    AllMenus = this.menu.all;
    get routeName(){
        return this.$route.name?.toString().split('-')[0];
    }
    SelectMenu(n: string) {
        this.menu.toggleTopMenu(n);
    }
}


